// src/pages/OrderLinesReport.js
import { auth } from "../firebase";

import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import Layout from "../components/Layout";
import { exportToExcel } from "../utils/exportToExcel";

function OrderLinesReport() {
  const today = new Date().toISOString().slice(0, 10);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTimeout(loadReport, 100);
  }, []);

  const toTs = (d, end = false) => {
    const dt = new Date(d);
    if (end) dt.setHours(23, 59, 59, 999);
    else dt.setHours(0, 0, 0, 0);
    return Timestamp.fromDate(dt);
  };

  const loadReport = async () => {
    try {
      setLoading(true);
      setLines([]);

      const q = query(
        collection(db, "orderLines"),
        where("approvedAt", ">=", toTs(fromDate)),
        where("approvedAt", "<=", toTs(toDate, true)),
		where("status", "==", "APPROVED")


      );

      const snap = await getDocs(q);
      const rows = [];

      snap.forEach((d) => {
        const r = d.data();

        rows.push({
          OrderID: r.displayOrderId || "",
          ApprovedDate: r.approvedAt?.toDate().toLocaleDateString("en-IN"),

          ClientId: r.clientId || "",          // ✅ NEW
		  VehicleNo: r.vehicleNo || "",        // ✅ NEW
		  Address: r.address || "",
		  gstno:r.gstno || "",
		  
		  PartyId: r.partyId || "",
          PartyName: r.partyName || "",
          PartyPhone: r.partyPhone || "",
          PartyType: r.partyType || "",
          DMSName: r.dmsName || "",
          EasyCigName: r.easyCigName || "",

          SKU: r.sku || "",
          ItemCode: r.itemCode || "",
          SKUName: r.skuName || "",
          Description: r.description || "",
          Brand: r.brand || "",
          MSKU: r.msku || "",
          Segment: r.segment || "",
          HSN: r.hsn || "",

          Qty: r.qty || 0,
          BasicRate: r.basicRate || 0,
          BasicAmount: r.basicAmount || 0,

          GST_pct: r.gstPercent || 0,
          GST_amt: r.gstAmount || 0,

          CESS_pct: r.cessPercent || 0,
          CESS_amt: r.cessAmount || 0,

          AddlCess_per_unit: r.addlCessPerUnit || 0,
          AddlCess_amt: r.addlCessAmount || 0,

          Rebate_per_unit: r.rebatePerUnit || 0,
          Rebate_amt: r.rebateAmount || 0,

          LineTotal: r.lineTotal || 0,
        });
      });

      rows.sort(
        (a, b) =>
          new Date(b.ApprovedDate) - new Date(a.ApprovedDate) ||
          b.OrderID.localeCompare(a.OrderID)
      );

      setLines(rows);
    } catch (e) {
      console.error(e);
      alert("Failed to load Order Lines Report");
    } finally {
      setLoading(false);
    }
  };

  const handleExport = () => {
    if (!lines.length) return alert("No data");
    exportToExcel({
      data: lines,
      fileName: `OrderLines_${fromDate}_${toDate}`,
      sheetName: "OrderLines",
    });
  };

  return (
    <Layout>
      <div style={{ padding: 20, overflowX: "auto" }}>
        <h2>Order Lines Report</h2>

        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

          <button onClick={loadReport}>
            {loading ? "Loading..." : "Load"}
          </button>

          <button
            onClick={handleExport}
            style={{ marginLeft: "auto", background: "green", color: "#fff" }}
          >
            Export XLSX
          </button>
        </div>

        {lines.length === 0 && !loading && <p>No records</p>}

        {lines.length > 0 && (
          <table border="1" cellPadding="6" style={{ minWidth: 2000 }}>
            <thead>
              <tr>
                {Object.keys(lines[0]).map((k) => (
                  <th key={k}>{k}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lines.map((r, i) => (
                <tr key={i}>
                  {Object.values(r).map((v, j) => (
                    <td key={j}>
                      {typeof v === "number" ? v.toFixed(2) : v}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </Layout>
  );
}

export default OrderLinesReport;
